(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["core-charge-checkbox"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const coreChargeOption = document.querySelector('.core-charge-option');
    if (!coreChargeOption) return;

    const radios = coreChargeOption.querySelectorAll('.core-charge-option__radio');
    if (radios.length === 0) return;

    // Find the product form component
    const section = coreChargeOption.closest('.shopify-section');
    const productFormComponent = section?.querySelector('product-form-component');
    if (!productFormComponent) return;

    const form = productFormComponent.querySelector('form');
    if (!form) return;

    // Find the add to cart button
    const addToCartButton = productFormComponent.querySelector('[ref="addToCartButton"]');
    if (!addToCartButton) return;

    // Store original disabled state info
    const wasOriginallyDisabled = addToCartButton.disabled;

    // Disable the add to cart button initially (no radio selected)
    // and show a hint message above it
    let hintEl = null;
    if (!wasOriginallyDisabled) {
      addToCartButton.disabled = true;
      addToCartButton.classList.add('core-charge-atc-disabled');

      hintEl = document.createElement('div');
      hintEl.className = 'core-charge-atc-hint';
      hintEl.textContent = 'Please choose a core charge option before purchasing';
      addToCartButton.parentElement.insertBefore(hintEl, addToCartButton);
    }

    // Track which radio is selected
    let selectedOption = null;

    // Enable button when a radio is selected
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        selectedOption = radio.value;
        if (!wasOriginallyDisabled) {
          addToCartButton.disabled = false;
          addToCartButton.classList.remove('core-charge-atc-disabled');
          if (hintEl) {
            hintEl.remove();
            hintEl = null;
          }
        }
      });
    });

    // Intercept the button click BEFORE it triggers form submission
    addToCartButton.addEventListener('click', async function(e) {
      if (!selectedOption) return; // Should not happen since button is disabled

      // "no-deposit" option: add the no-core-deposit variant alongside the product
      // "deposit" option: add the core charge variant alongside the product
      // Both cases need to add an extra item, so we intercept both

      // Stop the click from propagating and triggering form submit
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const formData = new FormData(form);
      const productVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1');

      if (!productVariantId) {
        console.error('Missing product variant ID');
        return;
      }

      // Disable button during submission
      addToCartButton.disabled = true;

      try {
        const items = [
          { id: parseInt(productVariantId), quantity: quantity }
        ];

        if (selectedOption === 'deposit') {
          const selectedRadio = coreChargeOption.querySelector('.core-charge-option__radio[value="deposit"]');
          const coreVariantId = selectedRadio.dataset.variantId;
          const skuElement = section?.querySelector('.product-sku');
          const productSku = skuElement?.textContent?.replace('SKU:', '').trim() || selectedRadio.dataset.productSku || '';

          items.push({
            id: parseInt(coreVariantId),
            quantity: quantity,
            properties: {
              'Associated SKU': productSku
            }
          });
        } else if (selectedOption === 'no-deposit') {
          const selectedRadio = coreChargeOption.querySelector('.core-charge-option__radio[value="no-deposit"]');
          const noDepositVariantId = selectedRadio.dataset.variantId;

          if (noDepositVariantId) {
            const skuElement = section?.querySelector('.product-sku');
            const productSku = skuElement?.textContent?.replace('SKU:', '').trim() || '';

            items.push({
              id: parseInt(noDepositVariantId),
              quantity: quantity,
              properties: {
                'Associated SKU': productSku
              }
            });
          }
        }

        // Add all items to cart via Shopify AJAX API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Failed to add items to cart');
        }

        const result = await response.json();

        // Fetch cart for drawer update
        const sectionsResponse = await fetch('/cart.js');
        const cart = await sectionsResponse.json();

        // Dispatch cart update event
        const event = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: productVariantId,
            data: {
              source: 'core-charge-radio',
              itemCount: cart.item_count
            }
          }
        });
        document.dispatchEvent(event);

        // Open the cart drawer
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Unable to add items to cart. Please try again.');
      } finally {
        // Re-enable button
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('core-charge-atc-disabled');
      }
    }, true); // Capture phase to intercept before any other handlers
  });
  } catch(e) { console.error(e); }
})();

})();
